import { cva } from '@/styled-system/css';

export const upsellBannerMediaRecipe = cva({
  base: {
    'lgDown': {
      position: 'absolute',
      insetBlockStart: 'UpsellBanner.Root.padding.vert',
      insetInlineStart: 'UpsellBanner.Root.padding.horz',
    },
    'lg': {
      display: 'flex',
      marginInlineEnd: 'UpsellBanner.Root.gap.trailing',
      flexShrink: 0,
    },

    '& > [data-c11n-component="Icon"]': {
      color: 'inherit',
      width: 'UpsellBanner.Media.icon.width',
      height: 'UpsellBanner.Media.icon.height',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'UpsellBanner.Media.neutral.icon',
      },
      soft: {
        color: 'UpsellBanner.Media.soft.icon',
      },
      hero: {
        color: 'UpsellBanner.Media.hero.icon',
      },
      impact: {
        color: 'UpsellBanner.Media.impact.icon',
      },
    },
  },
});
